import { useSelector } from 'react-redux';

import { useGetByReleaseStatusQuery } from 'store/api/configService/gameController';
import { viewModeSelector } from 'store/slices/viewMode';

import { findPathPages } from 'utils/pages';
import { VIEW_MODE } from 'utils/viewMode';

import { Skeleton } from '@mui/material';

import Card from 'components/GameItem/Card/Card';
import AnimationLayout from 'components/Layouts/Animation/AnimationLayout';
import HomeComponentsLayout from 'components/Layouts/HomeComponents/HomeComponentsLayout';

import { RELEASE_STATUSES } from 'components/config/games';
import { PAGE_PATH } from 'components/config/pages';
import { PROVIDERS } from 'config/organization';

import styles from './LatestReleases.module.scss';

const itemsSizes = {
  [VIEW_MODE.SIMPLE]: 4,
  [VIEW_MODE.WIDE]: 6,
};

const LatestReleases = () => {
  const viewMode = useSelector(viewModeSelector.getViewMode);

  const { data, isLoading } = useGetByReleaseStatusQuery({
    provider: PROVIDERS.evoplay,
    releaseStatus: RELEASE_STATUSES.released,
    count: itemsSizes[viewMode],
  });

  if (!isLoading && !data?.length) return null;

  return (
    <HomeComponentsLayout
      linkPath={findPathPages(PAGE_PATH.ALL_GAMES).replace(
        ':provider',
        PROVIDERS.evoplay,
      )}
      title="Latest Releases"
      linkTitle="All Evoplay Games"
      styleWrapper={styles.wrapper}
      styleHeader={styles.header}
    >
      {!isLoading ? (
        <AnimationLayout animation="fadeInLeft">
          <div className={styles.content}>
            {data.map((item) => (
              <Card key={item.id} item={item} />
            ))}
          </div>
        </AnimationLayout>
      ) : (
        <div className={styles.content}>
          {Array(itemsSizes[viewMode])
            .fill(null)
            .map((_, index) => (
              <Skeleton
                key={index}
                variant="rounded"
                width={220}
                height={220}
              />
            ))}
        </div>
      )}
    </HomeComponentsLayout>
  );
};

export default LatestReleases;
